import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: window.location.origin,
  headers: {
    'Content-type': 'application/json'
  }

})

export default axiosInstance



// WEBPACK FOOTER //
// ./src/http.js